import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Input from '../../components/Input'
import PasswordCheck from '../../components/PasswordCheck'
import request from '../../utils/request'

@observer
export default class UserPassword extends Component {
  @observable error = false
  @observable loading = false
  @observable success = false
  @observable changed = false

  @observable
  fields = {
    newPassword: '',
    confirmNewPassword: '',
    currentPassword: '',
  }

  @action
  setField = event => {
    this.error = false
    this.success = false
    this.changed = true
    this.fields[event.target.name] = event.target.value
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
    this.success = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  @action
  setSuccess = () => {
    this.loading = false
    this.error = false
    this.success = true
    this.changed = false
    this.fields.newPassword = ''
    this.fields.confirmNewPassword = ''
    this.fields.currentPassword = ''
  }

  submit = async event => {
    event.preventDefault()

    if (this.fields.confirmNewPassword !== this.fields.newPassword) {
      this.setError()
      return
    }

    this.setLoading()

    const res = await request('/api/user/updatePassword', {
      newPassword: this.fields.newPassword,
      currentPassword: this.fields.currentPassword,
    })

    if (res.success) {
      this.setSuccess()
    } else {
      this.setError()
    }
  }

  render() {
    return (
      <Card>
        <form onSubmit={this.submit}>
          {this.error && <Card.ErrorMessage />}
          {this.success && <Card.SavedMessage />}
          <Card.Pad>
            <Input
              name="newPassword"
              label="titles.newPassword"
              disabled={this.loading}
              value={this.fields.newPassword}
              onChange={this.setField}
              type="password"
            />
            {this.changed &&
              <Fragment>
                <PasswordCheck password={this.fields.newPassword} />
                <Input
                  name="confirmNewPassword"
                  label="titles.confirmNewPassword"
                  disabled={this.loading}
                  value={this.fields.confirmNewPassword}
                  onChange={this.setField}
                  type="password"
                />
                <Input
                  name="currentPassword"
                  label="titles.currentPassword"
                  disabled={this.fields.loading}
                  value={this.fields.currentPassword}
                  onChange={this.setField}
                  type="password"
                />
              </Fragment>
            }
          </Card.Pad>
          {this.changed &&
            <Fragment>
              <Card.Divider />
              <Card.Pad>
                <Button
                  color="blue"
                  disabled={this.loading}
                  str="titles.save"
                  type="submit"
                />
              </Card.Pad>
            </Fragment>
          }
        </form>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Profile/UserPassword.js